var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DogRecipeInfo } from '@content/products/meals';
import Flyout from '@marketing/components/funnel/Flyout';
import Accordion from '@marketing/components/funnel/Flyout/Accordion';
import ProductCard from '@marketing/components/funnel/ProductCard';
import { NewProduct, ProductImageNameAndPrice, TopPick, } from '@marketing/components/funnel/ProductCard/ProductCard';
import AAFCONutritionLabel from '@marketing/components/global/misc/AAFCONutritionLabel';
import { recipeInfo } from '@marketing/content';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import SelectRecipesText from '@marketing/profile/common/SelectRecipesText';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { getMaxNumPets, getRecommendedRecipes, prioritizeProducts } from '../../utils';
import { getMaxNumSelectableRecipes, isOutOfStockRecipe } from '@utils/common_utils';
import { FREE_PRODUCT_DISPLAY_NAMES, RECIPE_MODE } from '@variables';
var RecipeDetails = function (_a) {
    var isFlyoutOpen = _a.isFlyoutOpen, isTopPick = _a.isTopPick, recipe = _a.recipe, toggleOpen = _a.toggleOpen;
    var description = recipe.description, descriptionLong = recipe.descriptionLong, displayName = recipe.displayName, ingredients = recipe.ingredients, isNew = recipe.isNew, priceIndicator = recipe.priceIndicator;
    var serverLoading = useProfileContext().serverLoading;
    return (_jsx(Flyout, __assign({ isOpen: isFlyoutOpen, onToggle: function () { return toggleOpen(recipe.name); } }, { children: _jsx("div", __assign({ className: "p-5 md:p-12" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-12 md:gap-16 mt-12" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-1 gap-4" }, { children: [_jsx(ProductImageNameAndPrice, { disabled: serverLoading, imageData: {
                                    src: recipeInfo[recipe.name].funnelImage.src,
                                    alt: recipeInfo[recipe.name].funnelImage.alt,
                                }, isFlyout: true, productId: recipe.name, productName: displayName, priceLevel: priceIndicator.length, type: "meal" }), _jsx("div", __assign({ className: "text-sm-reg-m md:text-sm-reg-d capitalize" }, { children: description })), isTopPick ? _jsx(TopPick, { onCard: false }) : isNew ? _jsx(NewProduct, { onCard: false }) : null] })), _jsxs("div", { children: [_jsx(Accordion, __assign({ className: "py-4", title: "Details" }, { children: _jsx("p", { children: descriptionLong }) })), _jsx(Accordion, __assign({ className: "py-4", title: "Nutrition" }, { children: _jsx(AAFCONutritionLabel, { recipe: recipe.name, type: "recipe" }) })), _jsx(Accordion, __assign({ className: "py-4", title: "Ingredients" }, { children: typeof ingredients === 'string' && _jsx("p", { children: ingredients }) }))] })] })) })) })));
};
var PetMealsForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), profileData = _a.profileData, currentPetIndex = _a.currentPetIndex, currentPet = _a.currentPet, currentPetSurvey = _a.currentPetSurvey, saveProfile = _a.saveProfile, sendFunnelGTMEvent = _a.sendFunnelGTMEvent, serverLoading = _a.serverLoading, updateCurrentPet = _a.updateCurrentPet, profileBasePath = _a.profileBasePath, freeGiftWithPurchase = _a.freeGiftWithPurchase;
    var petRecipes = profileData.recipes
        .filter(function (recipe) { return recipe.petType === currentPet.petType && !recipe.deleted; })
        .map(function (recipe) {
        return __assign(__assign({}, recipe), DogRecipeInfo[recipe.name]);
    });
    var _b = useState(function () {
        if (currentPet.recipe) {
            return currentPet.recipeMode === RECIPE_MODE.MIX ? currentPet.recipeMix : [currentPet.recipe];
        }
        return [];
    }), recipes = _b[0], setRecipes = _b[1];
    var _c = useState(false), isFlyoutOpen = _c[0], setIsFlyoutExpanded = _c[1];
    var _d = useState(petRecipes[0]), clickedRecipe = _d[0], setClickedRecipe = _d[1];
    var maxSelectableRecipes = useMemo(function () {
        return getMaxNumSelectableRecipes(profileData.daysOfFood, currentPet.mealsPerDay, petRecipes.length);
    }, [currentPet.mealsPerDay]);
    var recommendedRecipes = useMemo(function () {
        var recommendedRecipes = getRecommendedRecipes(currentPetSurvey.purchasingMotivations, maxSelectableRecipes, currentPet.currentWeight > currentPet.weight);
        if (!currentPet.recipe) {
            setRecipes(recommendedRecipes);
        }
        return recommendedRecipes;
    }, [currentPetSurvey.purchasingMotivations, maxSelectableRecipes]);
    var toggleFlyout = function (recipeName) {
        setClickedRecipe(function () {
            return __assign(__assign({}, petRecipes.find(function (recipe) { return recipe.name === recipeName; })), DogRecipeInfo[recipeName]);
        });
        setIsFlyoutExpanded(function (prev) { return !prev; });
    };
    var handleSelectRecipe = function (recipeName) {
        var selectedRecipes = recipes.includes(recipeName)
            ? recipes.filter(function (selectedRecipe) { return selectedRecipe !== recipeName; })
            : __spreadArray(__spreadArray([], recipes, true), [recipeName], false);
        setRecipes(selectedRecipes);
        updateCurrentPet({
            recipeMode: selectedRecipes.length > 1 ? RECIPE_MODE.MIX : RECIPE_MODE.FIXED,
            recipe: selectedRecipes[0],
            recipeMix: selectedRecipes.length > 1 ? selectedRecipes : [],
        });
    };
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/purchasing_motivations"), {
            viewTransition: true,
        });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var petsCopy, nextPath, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    updateCurrentPet({
                        recipeMode: recipes.length > 1 ? RECIPE_MODE.MIX : RECIPE_MODE.FIXED,
                        recipe: recipes[0],
                        recipeMix: recipes.length > 1 ? recipes : [],
                    });
                    petsCopy = profileData.pets.map(function (pet, index) {
                        return index === Number(currentPetIndex)
                            ? __assign(__assign({}, pet), { recipeMode: recipes.length > 1 ? RECIPE_MODE.MIX : RECIPE_MODE.FIXED, recipe: recipes[0], recipeMix: recipes.length > 1 ? recipes : [] }) : pet;
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveProfile({ pets: petsCopy })];
                case 2:
                    _a.sent();
                    sendFunnelGTMEvent('click-next_meals_VERSION');
                    nextPath = profileData.pets.length === getMaxNumPets(profileData.version)
                        ? 'addons'
                        : 'add_another_dog';
                    navigate("".concat(profileBasePath, "/").concat(nextPath), { viewTransition: true });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var prioritizedRecipes = prioritizeProducts(petRecipes, recommendedRecipes);
    var formId = 'pet-meals-form';
    return (_jsxs(ProfileFormLayout, __assign({ disableNext: recipes.length === 0, formId: formId, handleClickPrevious: handleClickPrevious }, { children: [_jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Recipes For Your Dog" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-6 md:gap-10" }, { children: [_jsxs("div", __assign({ className: "text-center" }, { children: [_jsxs("h2", __assign({ className: "font-medium" }, { children: [currentPet.name, "\u2019s Recipe Recommendations"] })), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-4" }, { children: [_jsx(SelectRecipesText, { recommendedRecipes: recommendedRecipes }), _jsxs("p", { children: ["If you\u2019d like to try something else, you can make changes below. Select up to", ' ', maxSelectableRecipes, " recipes.", freeGiftWithPurchase && (_jsxs(_Fragment, { children: [' ', "FREE ", FREE_PRODUCT_DISPLAY_NAMES[freeGiftWithPurchase.productType], " will be automatically added to your order!"] }))] })] }))] })), _jsx("form", __assign({ id: formId, className: "grid grid-cols-1 md:grid-cols-2 gap-6 px-5 md:p-0", onSubmit: handleSubmit }, { children: prioritizedRecipes.map(function (recipe) {
                                var _a = DogRecipeInfo[recipe.name], isNew = _a.isNew, priceIndicator = _a.priceIndicator;
                                var disabled = serverLoading ||
                                    (recipes.length > 0 &&
                                        maxSelectableRecipes === recipes.length &&
                                        !recipes.includes(recipe.name));
                                var isOutOfStock = isOutOfStockRecipe(recipe.name, currentPet.gramsBucket);
                                return (_jsx(ProductCard, { disabled: disabled || isOutOfStock, handleSelectProduct: handleSelectRecipe, imageData: {
                                        src: recipeInfo[recipe.name].funnelImage.src,
                                        alt: recipeInfo[recipe.name].funnelImage.alt,
                                    }, ingredients: recipe.description, isNew: isNew, isOutOfStock: isOutOfStock, isTopPick: recommendedRecipes.includes(recipe.name), isSelected: recipes.includes(recipe.name), priceLevel: priceIndicator.length, productId: recipe.name, productName: recipe.displayName, toggleFlyout: toggleFlyout, type: "meal" }, "dog-recipe-".concat(recipe.name)));
                            }) }))] })) })), _jsx(RecipeDetails, { isFlyoutOpen: isFlyoutOpen, isTopPick: recommendedRecipes.includes(clickedRecipe.name), recipe: clickedRecipe, toggleOpen: toggleFlyout })] })));
};
export default PetMealsForm;
